"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchByID = void 0;
const AbstractSearchCommand_1 = require("./AbstractSearchCommand");
class SearchByID extends AbstractSearchCommand_1.AbstractSearchCommand {
    constructor(filter) {
        super();
        this.execute = async (api) => {
            const url = `/applications/${this.filter.pushApplicationID}`;
            const response = await api.get(url, {
                params: {
                    includeDeviceCount: true,
                    includeActivity: true,
                },
                validateStatus: (status) => (status >= 200 && status < 300) || status === 404,
            });
            if (response.status === 404) {
                return {
                    list: [],
                    total: 0,
                };
            }
            const apps = this.applyPushApplicationFilter(this.ensureIsArray(response.data), this.filter).map((app) => this.addActivityData(app, response));
            return {
                list: apps,
                total: apps.length,
            };
        };
        this.filter = filter;
    }
}
exports.SearchByID = SearchByID;
//# sourceMappingURL=SearchByID.js.map